// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Autenticazione (Supabase Auth) ======
// Lo stato dell'utente loggato viene letto da Supabase Auth + tabella utenti_portale.
// In memoria mantengo un oggetto `currentUserProfile` che riflette il record di
// utenti_portale, così il resto dell'app (getCurrentUser, isAdmin, ecc.) non cambia.

let currentUserProfile = null;

async function fetchCurrentUserProfile() {
  const {
    data: { user }
  } = await sb.auth.getUser();
  if (!user) {
    currentUserProfile = null;
    return null;
  }
  const { data, error } = await sb
    .from('utenti_portale')
    .select('id, user_id, email, name, role, risorsa_id, active, risorse(nome)')
    .eq('user_id', user.id)
    .maybeSingle();
  if (error) {
    console.error('fetchCurrentUserProfile error', error);
    currentUserProfile = null;
    return null;
  }
  if (!data || !data.active) {
    currentUserProfile = null;
    return null;
  }
  currentUserProfile = {
    id: data.user_id, // auth.users.id (UUID Supabase Auth)
    portaleId: data.id, // utenti_portale.id (id del profilo applicativo)
    email: data.email,
    name: data.name,
    role: data.role,
    resourceName: data.risorse?.nome || '',
    active: data.active
  };
  return currentUserProfile;
}

function getCurrentUser() {
  return currentUserProfile;
}

function isAdmin() {
  return !!currentUserProfile && currentUserProfile.role === 'admin';
}

function isUtente() {
  return !!currentUserProfile && currentUserProfile.role === 'utente';
}

function canSee(view) {
  if (isAdmin()) return true;
  return !ADMIN_VIEWS.has(view);
}

function applyRoleClass() {
  document.body.classList.toggle('role-utente', isUtente());
  document.body.classList.toggle('role-admin', isAdmin());
}

function renderLogin() {
  const form = $('#loginForm');
  const err = $('#loginError');
  if (err) err.classList.add('hidden');
  if (form) {
    form.reset();
    if (!form._wired) {
      form._wired = true;
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = ($('#loginEmail').value || '').trim().toLowerCase();
        const password = $('#loginPassword').value || '';
        await doLogin(email, password);
      });
    }
  }
  const forgot = $('#btnForgotPw');
  if (forgot && !forgot._wired) {
    forgot._wired = true;
    forgot.addEventListener('click', doPasswordReset);
  }
}

// Invio email di reimpostazione password (Supabase Auth). Usa l'email scritta
// nel campo di login: la mail parte solo verso l'indirizzo digitato dall'utente,
// nessun canale esterno custom.
async function doPasswordReset() {
  const email = ($('#loginEmail')?.value || '').trim().toLowerCase();
  const err = $('#loginError');
  const show = (msg) => {
    if (err) {
      err.textContent = msg;
      err.classList.remove('hidden');
    }
  };
  if (!email) {
    show('Scrivi prima la tua email qui sopra, poi premi di nuovo "Password dimenticata?".');
    $('#loginEmail')?.focus();
    return;
  }
  try {
    const { error } = await sb.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin
    });
    if (error) {
      show("Non è stato possibile inviare l'email: " + error.message);
      return;
    }
    if (err) err.classList.add('hidden');
    if (typeof toast === 'function')
      toast("Ti abbiamo inviato un'email per reimpostare la password (controlla anche lo spam).");
  } catch (e) {
    show('Errore: ' + (e?.message || e));
  }
}

async function doLogin(email, password) {
  const err = $('#loginError');
  const showErr = (msg) => {
    if (err) {
      err.textContent = msg;
      err.classList.remove('hidden');
    }
  };
  if (!email || !password) {
    showErr('Inserisci email e password.');
    return;
  }

  const { data, error } = await sb.auth.signInWithPassword({ email, password });
  if (error) {
    if (error.message && /invalid login/i.test(error.message))
      showErr('Email o password non validi.');
    else if (error.message && /email not confirmed/i.test(error.message))
      showErr('Email non confermata. Controlla la posta.');
    else showErr('Errore di accesso: ' + error.message);
    return;
  }

  const profile = await fetchCurrentUserProfile();
  if (!profile) {
    await sb.auth.signOut();
    showErr('Utente non autorizzato sul portale. Contatta un amministratore.');
    return;
  }

  state.currentUser = profile.name;
  try {
    if (typeof setSyncState === 'function') setSyncState('refreshing');
    await loadStateFromSupabase();
    if (typeof setSyncState === 'function') setSyncState('ok');
  } catch (e) {
    console.error('Errore caricamento dati', e);
    if (typeof setSyncState === 'function') setSyncState('error');
    showErr('Errore caricamento dati dal server');
    return;
  }
  logAudit({
    action: 'system',
    entity: 'Sistema',
    target: 'Login',
    details: `Accesso effettuato da ${profile.name} (${profile.role})`
  });
  if (err) err.classList.add('hidden');
  showApp();
  renderAll();
  setView('dashboard');
  toast(`Benvenuto, ${profile.name.split(' ')[0]}`);
  // Fallback: se il backup automatico più recente è vecchio, ne crea uno (best effort).
  if (typeof ensureRecentAutoBackup === 'function') ensureRecentAutoBackup();
  // Bootstrap notifiche: fetch unread, subscribe realtime, mostra riepilogo
  if (typeof bootstrapNotificationsForLogin === 'function') bootstrapNotificationsForLogin();
  // Carica catalogo ruoli (popola le datalist di autocomplete)
  if (typeof loadRuoliPredefiniti === 'function') loadRuoliPredefiniti();
  // Realtime collaborativo: subscribe a clienti/accessi/scadenze/...
  if (typeof startDataRealtime === 'function') startDataRealtime();
  // Polling per nuove versioni del bundle
  if (typeof startVersionWatch === 'function') startVersionWatch();
}

async function doLogout() {
  const u = getCurrentUser();
  // IMPORTANTE: aspettare la scrittura su audit_log PRIMA del signOut,
  // altrimenti la sessione viene invalidata e l'insert viene bloccato da RLS.
  if (u) {
    try {
      await logAudit({
        action: 'system',
        entity: 'Sistema',
        target: 'Logout',
        details: `Disconnessione di ${u.name}`
      });
    } catch (e) {
      console.error('Errore log logout', e);
    }
  }
  // Chiude i canali realtime prima del signOut
  if (typeof stopNotificationRealtime === 'function') stopNotificationRealtime();
  if (typeof stopDataRealtime === 'function') stopDataRealtime();
  await sb.auth.signOut();
  currentUserProfile = null;
  applyRoleClass();
  showLogin();
}

function showLogin() {
  $('#loginOverlay').classList.remove('hidden');
  $('#appRoot').classList.add('hidden');
  renderLogin();
}

function showApp() {
  $('#loginOverlay').classList.add('hidden');
  $('#appRoot').classList.remove('hidden');
  applyRoleClass();
}

// Reagisce a cambi di sessione (logout da un'altra tab, scadenza token, ecc.)
sb.auth.onAuthStateChange(async (event, session) => {
  if (event === 'SIGNED_OUT') {
    currentUserProfile = null;
    applyRoleClass();
    showLogin();
  }
});

Object.assign(globalThis, {
  fetchCurrentUserProfile,
  getCurrentUser,
  isAdmin,
  isUtente,
  canSee,
  applyRoleClass,
  renderLogin,
  doLogin,
  doPasswordReset,
  doLogout,
  showLogin,
  showApp
});
export {};
